import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-loading',
  standalone: true,
  imports: [],
  template: `
    @if (loading()) {
      <div class="loading-wrapper">
        <div class="shine-wrapper">
          <div class="shine"></div>
          <img src="/assets/logos/kanek/kanek-logo-black.png" />
        </div>
      </div>
    }
  `,
  styles: `
    .loading-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.5);
      backdrop-filter: blur(10px);
      z-index: 16777271;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #000;
      cursor: wait;
    }

    .shine-wrapper {
      position: absolute;
      max-width: 240px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      pointer-events: none;
      user-select: none;

      &:after {
        content: 'Loading...';
        position: absolute;
        display: block;
        font-size: var(--font-size-xl);
        text-align: center;
        bottom: -3rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .shine {
      /* Positioning */
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
      z-index: 999;

      /* Mask properties */
      mask-repeat: no-repeat;
      mask-size: cover;
      mask-image: url(/assets/logos/kanek/kanek-logo-black.png);

      &:before {
        content: '';
        z-index: 10;
        position: absolute;
        height: 200%;
        width: 200%;
        top: -120%;
        left: -120%;
        background: linear-gradient(transparent 0%,
                    rgba(255, 255, 255, 0.1) 35%,
                    rgba(255, 255, 255, 0.5) 50%,
                    rgba(255, 255, 255, 0.1) 65%,
                    transparent 100%);
        transition: all 2s;
        transform: rotate(-45deg);
        animation: shine 2s infinite forwards;
      }
    }

    @keyframes shine {
      0% {
          top: -120%;
          left: -120%;
      }
      100% {
          left:100%;
          top:100%;
      }
    }
  `,
})
export class LoadingComponent {
  loading = input<boolean>(false);
}
